import React, { Component } from 'react';
import { Form, Input, Spin } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { authActions } from 'redux/actions';
import { RegistrationImage } from 'images';
const FormItem = Form.Item;

class RegisteredForm extends Component {
  static propTypes = {
    handelCloseModal: PropTypes.func,
    userName: PropTypes.string,
  };

  render() {
    const { userName } = this.props;

    return (
      <div style={{ textAlign: 'center', marginBottom: '16px' }}>
        <img
          style={{ maxWidth: '352px' }}
          src={RegistrationImage}
          alt="Registration image"
        />
        <p>
          {userName ? (
            <span style={{ fontWeight: 600 }}>Salam, {userName}!</span>
          ) : (
            <span style={{ fontWeight: 600 }}>Salam!</span>
          )}{' '}
          <br />
          Wir freuen uns, dass du nun Teil der Community bist. <br />
          Bitte bestätige noch deine E-Mail-Adresse. <br />
          {/*Keine Bestätigungsmail erhalten? {" "}<span style={{ textDecoration: 'underline' }}>Erneut senden.</span> <br />*/}
          <br />
          Sobald deine E-Mail-Adresse bestätigt ist, kannst du mit deinem
          Projekt fortfahren.
        </p>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { user, loading, errors, singUpSuccess } = state.authentication;
  return {
    user,
    loading,
    errors,
    singUpSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  register: (user) => dispatch(authActions.register(user)),
  loginWithGoogle: (user) => dispatch(authActions.loginWithGoogle(user)),
});
export default connect(mapStateToProps, mapDispatchToProps)(RegisteredForm);
